import { Capacitor } from '@capacitor/core'
import OrganizationStorage from '../storage/organization-storage/OrganizationStorage'
import { getOrganizationById, IOrganization } from '../../config/organizations'

// Native-only: the three fixed web deploys (development/frisco-test/frisco-production
// nginx builds) never read organization storage, so they're unaffected regardless of
// what's in localStorage. A stored id that no longer resolves (removed from the list,
// typo, stale from a future migration) correctly returns undefined here too — that's
// what lets the organization picker reopen instead of silently falling back while
// still hiding itself.
export const getSelectedOrganization = (): IOrganization | undefined =>
  Capacitor.isNativePlatform() ? getOrganizationById(OrganizationStorage.get() ?? '') : undefined

// Native + a known organization selected -> that organization's backend.
// Everything else (web, native before any pick, or a stale/unknown stored id) ->
// the build's baked REACT_APP_API_URL, exactly as before this feature existed.
export const resolveApiBaseUrl = (): string | undefined =>
  getSelectedOrganization()?.apiUrl ?? process.env.REACT_APP_API_URL
